import { createApp } from 'vue'
import App from './App.vue'

import router from './router'

import './assets/main.css'
import './assets/app.css'
import './registerServiceWorker'
import '@/utils/axios'
import '@/utils/pocket.js'
import auth from '@/utils/auth'
import moment from 'moment'


let app = createApp(App)
moment.locale('mn')

app.use(auth)
app.use(moment)
app.use(router)

app.mount('#app')


app.config.globalProperties.$filters = {
  toCurrency(value) {
    if (typeof value !== "number") {
      return value;
    }
    var formatter = new Intl.NumberFormat('mn-MN', { style: 'decimal' });
    return formatter.format(value);
  }
}

const globals = app.config.globalProperties

export { globals }